import { useContext, useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from '@utils/AppContext';
import { HOME_PAGE_TYPE, IMAGE_TYPE } from "@utils/CONST"
import eventBus from '@utils/eventBus'
import styles from './index.module.scss'
import PayModal from '@view/compoents/payModal/payModal'
import Iconfont from '@utils/Iconfont';

import hp_cloth_normal from '@assets/images/home32x/hp_cloth_normal.svg';
import hp_cloth_active from '@assets/images/home32x/hp_cloth_active.svg';

import hp_model_normal from '@assets/images/home32x/hp_model_normal.svg';
import hp_model_active from '@assets/images/home32x/hp_model_active.svg';

import hp_shoes_normal from '@assets/images/home32x/hp_shoes_normal.svg';
import hp_shoes_active from '@assets/images/home32x/hp_shoes_active.svg';

import hp_video_normal from '@assets/images/home32x/hp_video_normal.svg';
import hp_video_active from '@assets/images/home32x/hp_video_active.svg';

import img2video_normal from '@assets/images/home32x/img2video_normal.svg';
import img2video_active from '@assets/images/home32x/img2video_active.svg';

import outfit_normal from '@assets/images/home32x/outfit_normal.svg';
import outfit_active from '@assets/images/home32x/outfit_active.svg';

import hp_goodsimage_normal from '@assets/images/home32x/hp_goodsimage_normal.svg';
import hp_goodsimage_active from '@assets/images/home32x/hp_goodsimage_active.svg';

import hp_goodscolorchange_normal from '@assets/images/home32x/hp_goodscolorchange_normal.svg';
import hp_goodscolorchange_active from '@assets/images/home32x/hp_goodscolorchange_active.svg';

import pose_image_normal from '@assets/images/home32x/pose_image_normal.svg';
import pose_image_active from '@assets/images/home32x/pose_image_active.svg';

import glass_image_normal from '@assets/images/home32x/glass_image_normal.svg';
import glass_image_active from '@assets/images/home32x/glass_image_active.svg';

import sim_image_normal from '@assets/images/home32x/sim_image_normal.svg';
import sim_image_active from '@assets/images/home32x/sim_image_active.svg';

import clothRecolor_normal from '@assets/images/home32x/clothRecolor_normal.svg';
import clothRecolor_active from '@assets/images/home32x/clothRecolor_active.svg';

import productShowcaseOutlined from '@assets/images/home32x/productShowcaseOutlined.svg';
import productShowcaseFilled from '@assets/images/home32x/productShowcaseFilled.svg';

import hp_bj_normal from '@assets/images/home32x/hp_bj_normal.svg';
import hp_bj_active from '@assets/images/home32x/hp_bj_active.svg';



const MENU_LIST = [
    {
        name: 'AI试衣',
        key: IMAGE_TYPE.CLOTHES,
        icon: hp_cloth_normal,
        icon_active: hp_cloth_active,
        pathname: "/home/homemain/clothes"
    }, {
        name: '同版型试衣',
        key: IMAGE_TYPE.SIM_TRYON,
        icon: sim_image_normal,
        icon_active: sim_image_active,
        pathname: "/home/homemain/simTryon",
        newIcon: true
    }, {
        name: '换模特',
        key: IMAGE_TYPE.MODEL,
        icon: hp_model_normal,
        icon_active: hp_model_active,
        pathname: "/home/homemain/model"
    }, {
        name: '鞋子上脚',
        key: IMAGE_TYPE.SHOES,
        icon: hp_shoes_normal,
        icon_active: hp_shoes_active,
        pathname: "/home/homemain/shoesTryon"
    }, {
        name: '眼镜试戴',
        key: IMAGE_TYPE.GLASSES_TRYON,
        icon: glass_image_normal,
        icon_active: glass_image_active,
        pathname: "/home/homemain/glassesTryon"
    }, {
        name: '姿势裂变',
        key: IMAGE_TYPE.POSE_TRYON,
        icon: pose_image_normal,
        icon_active: pose_image_active,
        pathname: "/home/homemain/poseTryon",
        newIcon: true
    }, {
        name: '商品图',
        key: IMAGE_TYPE.COMMODITY,
        icon: hp_goodsimage_normal,
        icon_active: hp_goodsimage_active,
        pathname: "/home/homemain/commodity"
    }, {
        name: '商品换色',
        key: IMAGE_TYPE.COMMODITYRECOLOR,
        icon: hp_goodscolorchange_normal,
        icon_active: hp_goodscolorchange_active,
        pathname: "/home/homemain/commodityRecolor"
    }, {
        name: '动作模仿',
        key: IMAGE_TYPE.MODEL_VIDEO,
        icon: hp_video_normal,
        icon_active: hp_video_active,
        pathname: "/home/homemain/model_video",
        teamIcon: true
    }, {
        name: '服饰换色',
        key: IMAGE_TYPE.CLOTH_RECOLOR,
        icon: clothRecolor_normal,
        icon_active: clothRecolor_active,
        pathname: "/home/homemain/clothRecolor",
    }, {
        name: '图生视频',
        key: IMAGE_TYPE.IMAGE_TO_VIDEO,
        icon: img2video_normal,
        icon_active: img2video_active,
        pathname: "/home/homemain/model_video_img",
        teamIcon: true
    }, {
        name: '搭配上身',
        key: IMAGE_TYPE.FUSION_WEAR,
        icon: outfit_normal,
        icon_active: outfit_active,
        pathname: "/home/homemain/fusionWear"
    }, {
        name: '种草图',
        key: IMAGE_TYPE.GRASS_PLANT,
        icon: productShowcaseOutlined,
        icon_active: productShowcaseFilled,
        pathname: "/home/homemain/grassPlant",
    }, {
        name: '服饰上身',
        key: '服饰上身',
        groupTitle: true
    }, {
        name: '组图生成',
        key: '组图生成',
        groupTitle: true
    }, {
        name: '换背景',
        key: IMAGE_TYPE.BACKGROUND,
        icon: hp_bj_normal,
        icon_active: hp_bj_active,
        pathname: "/home/homemain/background"
    },
]

const Sidebar = () => {
    const navigate = useNavigate();
    const { globalHomePageType } = useContext(AppContext);
    const location = useLocation()

    // 侧边栏列表
    const menuList = useMemo(() => {
        if (globalHomePageType == HOME_PAGE_TYPE.CLOTHING) {
            return [
                MENU_LIST[13], // 标题
                MENU_LIST[0], // AI试衣
                MENU_LIST[1], // 同版型试衣
                MENU_LIST[11], // 搭配上身
                MENU_LIST[3], // 鞋子上脚
                MENU_LIST[4], // 眼镜试戴
                MENU_LIST[14], // 标题
                MENU_LIST[2], // 换模特
                MENU_LIST[15], // 换背景
                MENU_LIST[12], // 种草图
                MENU_LIST[5], // 姿势裂变
                MENU_LIST[9], // 服饰换色
            ]
        } else if (globalHomePageType == HOME_PAGE_TYPE.MERCHANDISE) {
            return [
                MENU_LIST[6], // 商品图
                MENU_LIST[7], // 商品换色
            ]
        } else if (globalHomePageType == HOME_PAGE_TYPE.MODEL_VIDEO) {
            return [
                MENU_LIST[8], // 动作模仿
                MENU_LIST[10], // 图生视频
            ]
        } else return []
    }, [globalHomePageType])

    const handleSpanClick = (menu) => {
        navigate(menu.pathname)
    }

    return (
        <div className={styles.Sidebar}>
            <div className={styles.Sidebar_top}>
                {
                    menuList.map(menu => (
                        <div
                            key={menu.key}
                            className={styles.Sidebar_item}
                            onClick={() => handleSpanClick(menu)}
                        >
                            {
                                menu.groupTitle ? <div className={styles.Sidebar_item_title}>{menu.name}</div> :
                                    <div className={styles.Sidebar_item_content}>
                                        <img
                                            className={styles.sidebar_icon}
                                            src={location.pathname == menu.pathname ? menu.icon_active : menu.icon}
                                            alt=""
                                        />
                                        <p style={{ color: location.pathname == menu.pathname ? '#006EFF' : '#5B6673' }}>{menu.name}</p>
                                        {menu.teamIcon && <span className={styles.teamIcon}></span>}
                                        {menu.newIcon && <span className={styles.newIcon}></span>}
                                    </div>
                            }
                        </div>
                    ))
                }
            </div>
            <div className={styles.Sidebar_bottom}>
                <div className={styles.RechargeTrigger} onClick={() => eventBus.emit('recharge')}>
                    <Iconfont type='icon-arcbeanrecharge' className={styles.Icon} />
                    <span>虹豆充值</span>
                </div>
                <div className={styles.ComplianceCopy}>
                    <span>结果由AI生成</span>
                    <span>持续调优中，请谨慎甄别</span>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;